import React, { FC } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import Button from '../../shared/buttonComponents/Button';
import VideoComponent from '../../shared/VideoComponent';

export const HomePage: FC = () => {
  const wizard = useWizard();

  return (
    <Layout>
      <div className="home-page-container">
        <div className="home-page-left-desktop">
          <div className="main-title">WELCOME<br/>TO ZØTAPAY, <br/>PRICE CHECKER!</div>
          <div className='cta-box'>
            <Button
              onClick={() => wizard.changeStep(WizardStep.REGION)}
              title="Start now - just a few steps"
            />
            <p className='button-subtitle'>Just a few steps</p>
          </div>
        </div>
        <div className="home-page-visual">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/home.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/home.png`}
          />
        </div>
        <div className="home-page-left-mobile">
          <div className="main-title">WELCOME TO<br/>ZØTAPAY PRICE<br/>PROPOSAL MACHINE</div>
          <div className='cta-box'>
            <Button
              onClick={() => wizard.changeStep(WizardStep.REGION)}
              title="Start now"
            />
            <p className='button-subtitle'>Just a few steps</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};